module.exports = __webpack_public_path__ + "poster.jpg?10bfe8cd76d0254df74990b112ab69a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster.jpg
// module id = 15
// module chunks = 0